import { Component, EventEmitter, inject, Input, OnChanges, Output } from '@angular/core';
import { setFormDirty } from '../../../../utils/form';
import { PriceList, PriceListService } from '../../../../woo_services.module/PriceListService';

@Component({
  selector: 'select-pricelist-form',
  templateUrl: './select-pricelist-form.component.html',
  standalone: false,
})
export class SelectPricelistForm implements OnChanges {
  readonly priceListService = inject(PriceListService);
  readonly getYear = this.priceListService.getYear;
  readonly setFormDirty = setFormDirty;

  availableYears: AvailableYear[] = [];
  availablePriceLists: PriceList[] = [];

  selectedPriceListYear: number;
  selectedPriceList: PriceList;

  @Input() priceLists: PriceList[] = [];
  @Output() onSubmit = new EventEmitter<{
    priceList: PriceList;
    year: number;
  }>();
  @Output() onAbort = new EventEmitter<void>();

  ngOnChanges(): void {
    this.updateListSelections();
  }

  updateListSelections(): void {
    this.availableYears = this.getAvailableYears(this.priceLists);
    this.availablePriceLists = this.priceLists;
  }

  priceListLabel(priceList: PriceList): string {
    return `Prislista för år ${this.getYear(priceList)}`;
  }

  creatNewPriceList(): void {
    this.onSubmit.emit({
      priceList: this.selectedPriceList,
      year: this.selectedPriceListYear,
    });
  }

  cancel(): void {
    this.onAbort.emit();
  }

  private getAvailableYears(priceLists: PriceList[]): AvailableYear[] {
    const currentYear = new Date().getFullYear();
    const yearsWithPriceList = priceLists.map(this.getYear);
    return Array.from(new Array(5)).map((_, i) => ({
      year: currentYear + i,
      disabled: yearsWithPriceList.includes(currentYear + i),
    }));
  }
}

interface AvailableYear {
  year: number;
  disabled: boolean;
}
